const storagePrefix = "opigo_web_";

const storage = {
  getToken: () => window.localStorage.getItem(`${storagePrefix}token`),
  setToken: (token) => window.localStorage.setItem(`${storagePrefix}token`, token),
  clearToken: () => window.localStorage.removeItem(`${storagePrefix}token`),
};

export default storage;

